import { Button, Stack } from '@mui/material';
import DropdownMenu from '../../global/DropdownMenu';
import { FooterAction } from '../../../interfaces';
import { BORDER } from './colors';

interface Props {
  onBack: () => void;
  overflowActions: FooterAction[];
}

function BackChevron() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round">
      <path d="m14 6-6 6 6 6" />
    </svg>
  );
}

function CustomerProfileActions({ onBack, overflowActions }: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: '24px' }}>
      <Button
        onClick={onBack}
        startIcon={<BackChevron />}
        sx={{
          minWidth: 0,
          p: 0,
          color: 'text.secondary',
          textTransform: 'none',
          '&:hover': { bgcolor: 'transparent' },
          typography: 'h5',
        }}>
        Back
      </Button>
      <DropdownMenu
        options={overflowActions}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        paperSx={{
          width: 236,
          border: '1px solid',
          borderColor: 'common.black',
          borderRadius: '10px',
          padding: '6px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          mt: '8px',
        }}
        button={{
          content: '···',
          keepDefaultStyles: true,
          sx: {
            width: 34,
            height: 34,
            minWidth: 0,
            borderRadius: '50px',
            border: `1px solid ${BORDER}`,
            backgroundColor: 'common.white',
            fontSize: 'body1.fontSize',
            lineHeight: 1,
            color: 'text.primary',
            '&:hover': { borderColor: 'common.black' },
          },
        }}
      />
    </Stack>
  );
}

export default CustomerProfileActions;
